/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert } from 'react-bootstrap';
import { ss, url, authJsonHeader, parseTimeString } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import WhereField from './WhereField';
import './EscapeForm.css';

import {
  upload,
} from '../../actions';


export class AutocompleteField extends Component {
  state = {
    q: '',
    suggestions: {},
  }

  componentDidMount() {
    this.suggest(this.state.q);
  }

  suggest(q) {
    this.setState({ q });

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = setTimeout(() => {
      this.timeoutId = null;
      this.props.getSuggestions(q, { background: true, silent: true })
        .then(resp => {
          this.setState({ suggestions: (resp.obj || {})})
            console.log('SUGGESTIONS', resp);
        });
    }, 200);
  }

  pickRoom(room) {
    console.log('pick room:', room);
    this.setState({ q: '' });
    this.props.onPick(room);
  }

  renderSuggestions() {
    let rooms = this.state.suggestions.rooms || [];
    let nodes = rooms.map(room => {
      let companyName = ' (?)';
      if (room.location) {
        companyName = room.location.company;
      }
      let text = room.name + ' - ' + companyName;
      let node = (
        <div key={room.id} onClick={() => this.pickRoom(room)}>
          <Highlighter
            highlightClassName="highlight"
            searchWords={[this.state.q]}
            autoEscape={true}
            textToHighlight={text}
          />
          <div className="room-address">{room.address}</div>
        </div>
      );
      return node;
    });

    return (
      <div className="ac">
        <div className="ac-group">
          <div className="ac-title">Rooms</div>
          <div className="ac-items">
            {nodes}
            {nodes.length == 0 && <div>No matches found...</div>}
          </div>
          <div className="ac-manual" onClick={() => this.props.onManual()}>Don't see it? Add new room</div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <FormControl
          value={this.state.q}
          onChange={(e) => this.suggest(e.target.value)}
        />
        {!!this.state.q && this.renderSuggestions()}
      </div>
    );
  }
}


class EscapeForm extends OzFormComponent {

  static fields = [
    'roomId',
    'roomName',
    'roomCompany',
    'roomCity',

    'teamId',
    'didEscape',
    'time',
    'seconds',
    'photo',
    'date',
  ];

  static cleaners = {
    date: { inbound: 'date', outbound: 'date' },
  }

  getValues() {
    let values = super.getValues();

    if (this.state.time) {
      let r = parseTimeString(this.state.time);
      values.time = r.time;
      values.seconds = r.seconds;
    }

    let roomFields = [
      'roomId',
      'roomName',
      'roomCompany',
      'roomCity',
    ];

    let escapeFields = [
      'teamId',
      'didEscape',
      'time',
      'seconds',
      'photo',
      'date',
    ];

    let room = {};
    for (let field of roomFields) {
      room[field] = values[field];
    }
    let escape = {};
    for (let field of escapeFields) {
      escape[field] = values[field];
    }
    return { room, escape };
  }

  setRoomId(room) {
    this.setState({ roomId: room.id, room: room });
  }

  setManual() {
    this.setState({
      roomId: null,
      room: null,
      manual: true,
    });
  }

  setWhere(where) {
    console.log('where:', where);
    this.setState({
      roomCity: where.name,
    })
  }

  commitManual() {
    this.setState({
      manualRoom: {
        name: this.state.roomName,
        company: this.state.roomCompany,
      }
    });
  }

  getRoom() {
    return this.state.manualRoom || this.state.room || this.props.values.room;
  }

  renderDidEscape() {
    let room = this.getRoom();

    return (
      <div className="did-escape">
        <div className="question">Did you escape<b> {room && room.name}</b>?</div>
        <div className="did-escape-choices">
          <div className={cx('did-escape-choice', 'yes', { active: this.state.didEscape })} onClick={() => this.setState({ didEscape: true })}>
            Yes!
          </div>
          <div className={cx('did-escape-choice', 'no', { active: this.state.didEscape != undefined && !this.state.didEscape })} onClick={() => this.setState({ didEscape: false })}>
            No...
          </div>
        </div>
      </div>
    );
  }

  renderButtons() {
    if (this.getRoom() && this.state.didEscape != undefined) {
      return super.renderButtons();
    }
    return null;
  }

  renderBody() {
    let rooms = this.props.rooms || [];
    let roomOptions = rooms.map(room => [
      room.id,
      room.name + ' (' + room.location.company + ')',
    ]);
    roomOptions.sort((a, b) => a[1].localeCompare(b[1]));

    let teamField = null;
    console.log('TEAMS-->', this.props.teamMemberships);
    if (this.props.teamMemberships && this.props.teamMemberships.length) {
      let teamOptions = this.props.teamMemberships.map(tm => [tm.team.id, tm.team.name]);
      console.log('teamOptions', teamOptions);
      teamField = this.renderFormGroup('Which team?', 'select', 'teamId', teamOptions);
    }

    console.log('ROOM PROPS?', this.props.values.room);
    let room = this.getRoom();

    let filledEscape = this.state.didEscape != undefined;

    let details = (
      <div>
        {this.renderDidEscape()}
        {filledEscape && this.state.didEscape && this.renderFormGroup('What was your time? (optional)', 'text', 'time', { placeholder: 'You can put in seconds if you want! eg. "45:13"'})}
        {filledEscape && this.renderFormGroup('When was this escape (optional, defaults to today)', 'date', 'date')}
        {filledEscape && teamField}
        {filledEscape && this.renderFormGroup('Escape photo (optional)', 'image', 'photo')}
      </div>
    );

    let enableMaualContinue = (
      this.state.roomName &&
      this.state.roomCompany &&
      this.state.roomCity
    );
    let manualRoomForm = (
      <div>
        {this.renderFormGroup('Room name', 'text', 'roomName')}
        {this.renderFormGroup('Company name', 'text', 'roomCompany')}
        {/*this.renderFormGroup('City', 'text', 'roomCity')*/}
        <FormGroup>
          <ControlLabel>City</ControlLabel>
          <WhereField
            onChange={(where) => this.setWhere(where)}
            onSelect={(where) => this.setWhere(where)}
          />
        </FormGroup>

        <FormGroup className="oz-form-buttons">
          <Button bsStyle="primary" disabled={!enableMaualContinue} onClick={() => this.commitManual()}>Continue</Button>
        </FormGroup>
      </div>
    );

    let showManualForm = this.state.manual;
    if (this.state.manualRoom) {
      room = this.state.manualRoom;
      showManualForm = false;
    }

    let showAutocomplete = !this.props.values.roomId && !this.state.manual;

    return (
      <div className="EscapeForm">
        {showAutocomplete && <div>
        <div>Which room do you want to add?</div>
        <AutocompleteField
         getSuggestions={this.props.getSuggestions}
         onPick={v => this.setRoomId(v)}
         onManual={() => this.setManual()}
         />
        </div>
         }

        {showManualForm && manualRoomForm}

        {room && (
          <div className="picked-room">
            <div className="picked-room-name">{room.name}</div>
            <div className="picked-room-company">{room.company}</div>
          </div>)
        }

        {room && details}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    upload: (...args) => dispatch(upload(...args)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EscapeForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/EscapeForm.js
 **/